import { Component, input } from '@angular/core';
import { Vector2ElementNormalized } from '@typings/vectors';

@Component({
  selector: 'lp-canvas-element-pivot',
  imports: [],
  templateUrl: './lp-canvas-element-pivot.component.html',
  styleUrl: './lp-canvas-element-pivot.component.css',
})
export class LpCanvasElementPivotComponent {
  pivot = input.required<Vector2ElementNormalized>();
}
